import React from 'react';
import {Switch, Redirect} from 'react-router-dom';
import ErrorBoundaryRoute from "../../../../containers/ErrorBoundaryRoute";
import Collection from './components/Kiosks';
import Object from './components/Kiosk';

export default ({history, match}) => (
	<div>
		<Switch>
			<ErrorBoundaryRoute exact path={`${match.url}`}>
				<Collection history={history} base={`${match.url}`}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute path={`${match.url}/:id`}>
				<Object history={history} baseUrl={`${match.url}`}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute>
				<Redirect to={`${match.url}`}/>
			</ErrorBoundaryRoute>
		</Switch>
	</div>
);
